package nacholab.supplies.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import nacholab.supplies.ui.theme.CommonStyles
import nacholab.supplies.ui.theme.SuppliesTheme
import org.jetbrains.compose.web.css.px

@Composable
fun NLButton(text: String, onClick: () -> Unit, modifier: Modifier = Modifier) {
    NLButton(
        content = {
            SpanText(
                text = text,
                modifier = Modifier
                    .fontSize(27.px)
                    .color(SuppliesTheme.colors.background)
                    .fontWeight(FontWeight.Bold)
            )
        },
        onClick = onClick,
        modifier = modifier
    )
}

@Composable
fun NLButtonLoading(modifier: Modifier = Modifier){
    Box(
        modifier = modifier
            .height(48.px)
            .background(SuppliesTheme.colors.primary)
            .padding(leftRight = 24.px)
            .clip(Rect(cornerRadius = 24.px))
            .then(CommonStyles.hoverPointer.toModifier()),
        contentAlignment = Alignment.Center
    ){
        NLLoadingInLine()
    }
}

@Composable
fun NLButton(content: @Composable () -> Unit, onClick: () -> Unit, modifier: Modifier = Modifier){
    Box(
        modifier = modifier
            .height(48.px)
            .background(SuppliesTheme.colors.primary)
            .padding(leftRight = 24.px)
            .clip(Rect(cornerRadius = 24.px))
            .onClick { onClick() }
            .then(CommonStyles.hoverPointer.toModifier()),
        contentAlignment = Alignment.Center
    ){ content() }
}